import { CLASS_TYPE, PRICE_OPTIONS } from '@/utils/filter/filterOptions.js';

const _getCategoryId = categoryIdstr => {
  if (!categoryIdstr) return undefined;
  const selectedCategoryId = Number(categoryIdstr);
  if (isNaN(selectedCategoryId)) return undefined;
  return [selectedCategoryId];
};

const _getMainCategoryName = (selectedCategory, categoryList) => {
  if (!selectedCategory) return undefined;
  const mainCategory = categoryList?.find(category => {
    return String(category.id) === String(selectedCategory);
  });
  if (!mainCategory) return undefined;
  const mainCategoryName = mainCategory?.name;
  return [mainCategoryName];
};

const _getSubCategoryName = ({
  selectedCategory,
  selectedSubCategory,
  categoryList,
}) => {
  if (!selectedCategory || !selectedSubCategory) return undefined;
  const mainCategory = categoryList?.find(category => {
    return String(category.id) === String(selectedCategory);
  });
  const subCategoryName = mainCategory?.children.find(
    subCategory => String(subCategory.id) === String(selectedSubCategory),
  )?.name;

  if (!subCategoryName) return undefined;
  return [subCategoryName];
};

// 필터 상태 로깅을 위한 유틸 함수
const getFilterLogText = (query, categoryList) => {
  const {
    keyword,
    order,
    selectedAge,
    selectedPrice,
    onlyDiscounted,
    selectedClassType,
    selectedCategory,
    selectedSubCategory,
    selectedPeriodOption,
    selectedDayOfWeek,
    startTimeIdx,
    endTimeIdx,
  } = query;

  const returnData = {};

  if (keyword) returnData.keyword = keyword;
  if (order) returnData.list_type = order;
  if (selectedAge) returnData.selected_age = selectedAge;
  if (selectedPrice) {
    PRICE_OPTIONS.filter(p => p.value === selectedPrice).forEach(price => {
      returnData.min_price = price.minPrice;
      returnData.max_price = price.maxPrice;
    });
  }

  // is_discount는 true or false로 늘 들어갑니다.
  returnData.is_discount = !!onlyDiscounted;

  if (selectedClassType) {
    returnData.class_type = selectedClassType.split(',').reduce((acc, cur) => {
      const text = CLASS_TYPE.find(ct => ct.value === parseInt(cur))?.text;
      return text ? acc.concat(text) : acc;
    }, []);
  }

  returnData.main_category_id = _getCategoryId(selectedCategory);
  returnData.sub_category_id = _getCategoryId(selectedSubCategory);
  returnData.main_category_name = _getMainCategoryName(
    selectedCategory,
    categoryList,
  );
  returnData.sub_category_name = _getSubCategoryName({
    selectedCategory,
    selectedSubCategory,
    categoryList,
  });

  if (selectedPeriodOption || selectedDayOfWeek || startTimeIdx || endTimeIdx)
    returnData.is_set_schedule = true;

  return returnData;
};

export default getFilterLogText;
